import api from './axios'

const contactUs = obj => api('contact/submit', 'POST', obj, false)

export default { contactUs }
